import { render, staticRenderFns } from "./fadeAlert.vue?vue&type=template&id=50097334&scoped=true&"
import script from "./fadeAlert.vue?vue&type=script&lang=js&"
export * from "./fadeAlert.vue?vue&type=script&lang=js&"
import style0 from "./fadeAlert.vue?vue&type=style&index=0&id=50097334&rel=stylesheet&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50097334",
  null
  
)

export default component.exports